<template>
    <div>
        <template v-if="asset">
            <div class="custom-container">
                <vs-button radius icon-pack="feather" size="large" icon="icon-save" @click="() => updateAsset()"
                           :class="{'pen': isLoading, 'changed-asset': isChanged }" class="fixed-button save"
                           id="save-asset-btn"/>
                <vs-button radius icon-pack="feather" color="danger" size="large" icon="icon-trash" @click="deleteAsset"
                           class="fixed-button delete"
                           v-if="$route.params.id && $store.state.user.role.name === 'Manager'"/>
                <vs-button radius icon-pack="feather" color="warning" size="large" icon="icon-copy" @click="duplicateAsset"
                           class="fixed-button duplicate"
                           :class="{'pen': isDuplicateLoading}"
                           v-if="$route.params.id && $store.state.user.role.name === 'Manager'"/>
                <vx-card class="mb-base" :class="{'no-edit': cantEditPublished}">
                    <div class="vx-row">
                        <div class="vx-col w-full sm:w-full md:w-2/3">
                            <div style="padding-right: 30px;">
                                <vx-input-group class="custom-input-group">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Name
                                        </div>
                                    </template>

                                    <div class="d-flex">
                                        <vs-input
                                            name="name"
                                            v-validate="$route.params.id ? 'required' : 'required'"
                                            placeholder="Name"
                                            v-model="asset.title"
                                            @keydown="checkName"
                                        />
                                        <span class="text-danger text-sm validation-error" v-show="errors.has('name')"
                                              v-html="errors.first('name')"></span>
                                        <span class="text-danger text-sm validation-error" v-show="isUniqName">This asset already exists, <a
                                            :href="'/' + isUniqName + '/edit'"
                                            target="_blank">click here to view</a> </span>
                                        <vx-tooltip
                                            class="help-tip"
                                            position="right"
                                            text="Name of the asset that encompasses all variations. Should be concise. E.g. “Solar System”">
                                            <i class="material-icons notranslate"> help_outline </i>
                                        </vx-tooltip>
                                    </div>
                                </vx-input-group>
                                <vx-input-group class="custom-input-group language-item" v-if="currentLanguage && currentLanguage.code !== 'en'">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            {{currentLanguage.name}}
                                        </div>
                                    </template>

                                    <div class="d-flex">
                                        <vs-input
                                            name="name"
                                            placeholder="Name"
                                            v-model="asset.locales[currentLanguage.code].name"
                                        />
                                    </div>
                                </vx-input-group>
                                <vx-input-group class="custom-input-group">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Description
                                        </div>
                                    </template>

                                    <div class="d-flex">
                                        <vs-textarea
                                          class="resize-vertical"
                                          name="description"
                                          placeholder="Description"
                                          v-model="asset.description"
                                        />
                                        <span class="text-danger text-sm validation-error"
                                              v-show="errors.has('description')">{{ errors.first('description') }}</span>
                                        <vx-tooltip
                                            class="help-tip"
                                            position="right"
                                            text="Longer and more descriptive name for the asset. E.g. “Solar system with all 9 planets”">
                                            <i class="material-icons notranslate"> help_outline </i>
                                        </vx-tooltip>
                                    </div>
                                </vx-input-group>
                                <vx-input-group class="custom-input-group language-item" v-if="currentLanguage && currentLanguage.code !== 'en'">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            {{currentLanguage.name}}
                                        </div>
                                    </template>

                                    <div class="d-flex">
                                      <vs-textarea
                                        class="resize-vertical"
                                        placeholder="Description"
                                        v-model="asset.locales[currentLanguage.code].description"
                                      />
                                    </div>
                                </vx-input-group>
                              <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                  <div class="prepend-text bg-dark">
                                    Primary Tags
                                  </div>
                                </template>
                                <div class="d-flex">
                                  <custom-tags :setTags="setPrimaryTags" :init-tags="asset.primary_keywords" lang="en" />
                                  <vx-tooltip
                                    class="help-tip"
                                    position="right"
                                    text="Primary keywords that makes searching easier: E.g. “sun, mercury, venus, earth, mars, planets, gas giants”">
                                    <i class="material-icons notranslate"> help_outline </i>
                                  </vx-tooltip>
                                </div>
                              </vx-input-group>
                              <vx-input-group class="custom-input-group language-item" v-if="currentLanguage && currentLanguage.code !== 'en'">
                                <template slot="prepend">
                                  <div class="prepend-text bg-dark">
                                    {{currentLanguage.name}}
                                  </div>
                                </template>

                                <div class="d-flex">
                                  <custom-tags :setTags="setPrimaryTags" :init-tags="asset.locales && asset.locales[currentLanguage.code] ? asset.locales[currentLanguage.code].primary_tags : asset.primary_keywords" :lang="currentLanguage.code" />
                                </div>
                              </vx-input-group>
                                <vx-input-group class="custom-input-group">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Tags
                                        </div>
                                    </template>
                                    <div class="d-flex">
<!--                                        <v-select ref="tags" taggable multiple @input="onTagChange" v-model="asset.keywords"-->
<!--                                                  :map-keydown="(map, vm) => handleCreatedTag(map, vm, 'keywords')"-->
<!--                                                  :select-on-key-codes="[13]"/>-->
                                      <custom-tags :setTags="setTags" :init-tags="asset.keywords" lang="en" />
                                        <vx-tooltip
                                            class="help-tip"
                                            position="right"
                                            text="Keywords that makes searching easier: E.g. “sun, mercury, venus, earth, mars, planets, gas giants”">
                                            <i class="material-icons notranslate"> help_outline </i>
                                        </vx-tooltip>
                                    </div>
                                </vx-input-group>
                                <vx-input-group class="custom-input-group language-item" v-if="currentLanguage && currentLanguage.code !== 'en'">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            {{currentLanguage.name}}
                                        </div>
                                    </template>

                                    <div class="d-flex">
                                      <custom-tags :setTags="setTags" :init-tags="asset.locales && asset.locales[currentLanguage.code] ? asset.locales[currentLanguage.code].tags : asset.keywords" :lang="currentLanguage.code" />
<!--                                        <v-select ref="tags" taggable multiple v-model="asset.locales[currentLanguage.code].tags"-->
<!--                                                  :map-keydown="(map, vm) => handleCreatedTag(map, vm, `tags`, currentLanguage.code)"-->
<!--                                                  :select-on-key-codes="[13]"/>-->
                                    </div>
                                </vx-input-group>
                                <vs-divider/>

                                <div class="vx-row">
                                    <div class="vx-col w-full sm:w-full md:w-1/2" :class="{'no-edit': $store.state.user.role.name === 'Academic' || $store.state.user.role.name === 'CopyEditors'}">
                                        <vx-input-group class="custom-input-group mb-0">
                                            <template slot="prepend">
                                                <div class="prepend-text bg-dark">
                                                    Type
                                                </div>
                                            </template>
                                            <div class="d-flex">
                                                <v-select name="type"
                                                          v-validate="'required'" :options="types"
                                                          v-model="asset.asset_type"
                                                          :reduce="item => item.value" label="name"/>
                                                <span class="text-danger text-sm validation-error"
                                                      v-show="errors.has('type')">{{ errors.first('type') }}</span>

                                            </div>
                                        </vx-input-group>
                                    </div>
                                    <div class="vx-col w-full sm:w-full md:w-1/2" :class="{'no-edit': $store.state.user.role.name === 'CopyEditors'}">
                                        <vx-input-group class="custom-input-group mb-0">
                                            <template slot="prepend">
                                                <div class="prepend-text bg-dark">
                                                    Subject
                                                </div>
                                            </template>

                                            <div class="d-flex">
                                                <v-select name="subject" multiple :options="$store.state.subjects"
                                                          v-model="asset.subject" :reduce="item => item" label="name"/>
                                                <vx-tooltip
                                                    class="help-tip"
                                                    position="right"
                                                    text="Subject that best matches the asset">
                                                    <i class="material-icons notranslate"> help_outline </i>
                                                </vx-tooltip>
                                            </div>
                                        </vx-input-group>
                                    </div>
                                </div>
                                <div v-if="asset.asset_type === 'video'" :class="{'no-edit': $store.state.user.role.name === 'Academic' || $store.state.user.role.name === 'CopyEditors'}">
                                    <vx-input-group class="custom-input-group">
                                        <template slot="prepend">
                                            <div class="prepend-text bg-dark">
                                                Video Type
                                            </div>
                                        </template>
                                        <div class="d-flex">
                                            <v-select name="type"
                                                      :options="video_types" v-model="asset.video_type"
                                                      :reduce="item => item" label="name"/>

                                        </div>
                                    </vx-input-group>
                                    <vx-input-group class="custom-input-group">
                                        <template slot="prepend">
                                            <div class="prepend-text bg-dark">
                                                Narrator
                                            </div>
                                        </template>
                                        <div class="d-flex">
                                            <v-select name="type"
                                                      :options="narrators" v-model="asset.narrator"
                                                      :reduce="item => item" label="name"/>

                                        </div>
                                    </vx-input-group>
                                </div>
                                <!--<vx-input-group class="custom-input-group">-->
                                <!--<template slot="prepend">-->
                                <!--<div class="prepend-text bg-dark">-->
                                <!--Category-->
                                <!--</div>-->
                                <!--</template>-->

                                <!--<div>-->
                                <!--<v-select name="category" v-validate="'required'" :options="categories" v-model="asset.category" :reduce="item => item.name" label="name" />-->
                                <!--<span class="text-danger text-sm validation-error" v-show="errors.has('category')">{{ errors.first('category') }}</span>-->
                                <!--</div>-->
                                <!--</vx-input-group>-->
                                <!--<vx-input-group class="custom-input-group">-->
                                <!--<template slot="prepend">-->
                                <!--<div class="prepend-text bg-dark">-->
                                <!--Sub Category-->
                                <!--</div>-->
                                <!--</template>-->
                                <!--<div>-->
                                <!--<v-select name="sub-category" v-validate="'required'" :options="subCategories" v-model="asset.sub_category" :reduce="item => item.name" label="name" />-->
                                <!--<span class="text-danger text-sm validation-error" v-show="errors.has('sub-category')">{{ errors.first('sub-category') }}</span>-->
                                <!--</div>-->
                                <!--</vx-input-group>-->

                                <!--                                <div class="vx-row">-->
                                <!--                                    <div class="vx-col w-full sm:w-full md:w-1/2">-->
                                <!--                                        <vx-input-group class="custom-input-group mb-0">-->
                                <!--                                            <template slot="prepend">-->
                                <!--                                                <div class="prepend-text bg-dark">-->
                                <!--                                                    Is a type of...-->
                                <!--                                                </div>-->
                                <!--                                            </template>-->
                                <!--                                            <div class="d-flex">-->
                                <!--                                                <v-select ref="tags" taggable multiple v-model="asset.typeKeywords"-->
                                <!--                                                          :map-keydown="(map, vm) => handleCreatedTag(map, vm, 'typeKeywords')"-->
                                <!--                                                          :select-on-key-codes="[188, 13]"/>-->
                                <!--                                                <vx-tooltip-->
                                <!--                                                    class="help-tip"-->
                                <!--                                                    position="right"-->
                                <!--                                                    text="Type keywords">-->
                                <!--                                                    <i class="material-icons notranslate"> help_outline </i>-->
                                <!--                                                </vx-tooltip>-->
                                <!--                                            </div>-->
                                <!--                                        </vx-input-group>-->
                                <!--                                    </div>-->
                                <!--                                    <div class="vx-col w-full sm:w-full md:w-1/2">-->
                                <!--                                        <vx-input-group class="custom-input-group mb-0">-->
                                <!--                                            <template slot="prepend">-->
                                <!--                                                <div class="prepend-text bg-dark">-->
                                <!--                                                    Is part of...-->
                                <!--                                                </div>-->
                                <!--                                            </template>-->
                                <!--                                            <div class="d-flex">-->
                                <!--                                                <v-select ref="tags" taggable multiple v-model="asset.partKeywords"-->
                                <!--                                                          :map-keydown="(map, vm) => handleCreatedTag(map, vm, 'partKeywords')"-->
                                <!--                                                          :select-on-key-codes="[188, 13]"/>-->
                                <!--                                                <vx-tooltip-->
                                <!--                                                    class="help-tip"-->
                                <!--                                                    position="right"-->
                                <!--                                                    text="Part keywords">-->
                                <!--                                                    <i class="material-icons notranslate"> help_outline </i>-->
                                <!--                                                </vx-tooltip>-->
                                <!--                                            </div>-->
                                <!--                                        </vx-input-group>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                                <vs-divider/>
                                <div class="vx-row">
                                    <div class="vx-col w-full sm:w-full md:w-1/2">
                                        <vx-input-group class="custom-input-group">
                                            <template slot="prepend">
                                                <div class="prepend-text bg-dark">
                                                    Academic Reviewed
                                                </div>
                                            </template>

                                            <div class="d-flex" :class="{'no-edit': $store.state.user.role.name !== 'Academic' && $store.state.user.role.name !== 'Manager'}">
                                                <div class="vx-input-group-append flex-grow">
                                                    <div class="append-text btn-addon">
                                                        <vs-button
                                                            color="primary"
                                                            type="border"
                                                            @click="setAcademicReviewed(true)"
                                                            class="radiobtn"
                                                            :class="{selected: asset.academic_reviewed}">
                                                            Yes
                                                        </vs-button>
                                                        <vs-button
                                                            color="primary"
                                                            type="border"
                                                            @click="setAcademicReviewed(false)"
                                                            class="radiobtn"
                                                            :class="{selected: !asset.academic_reviewed}">
                                                            No
                                                        </vs-button>
                                                    </div>
                                                </div>
                                                <span class="text-danger text-sm validation-error"
                                                      v-show="errors.has('test')">{{ errors.first('test') }}</span>
                                                <vx-tooltip
                                                    class="help-tip"
                                                    position="right"
                                                    :text="asset.academic_reviewed_by || asset.academic_reviewed_at ? asset.academic_reviewed_by + '</br>' + new Date(asset.academic_reviewed_at).toLocaleString(): 'Default status'"
                                                >
                                                    <i class="material-icons notranslate"> help_outline </i>
                                                </vx-tooltip>
                                            </div>
                                        </vx-input-group>

                                    </div>
                                    <div class="vx-col w-full sm:w-full md:w-1/2">
                                        <vx-input-group class="custom-input-group">
                                            <template slot="prepend">
                                                <div class="prepend-text bg-dark">
                                                    Artist Reviewed
                                                </div>
                                            </template>

                                            <div class="d-flex" :class="{'no-edit': $store.state.user.role.name !== 'Media' && $store.state.user.role.name !== 'Manager'}">
                                                <div class="vx-input-group-append flex-grow">
                                                    <div class="append-text btn-addon">
                                                        <vs-button
                                                            color="primary"
                                                            type="border"
                                                            @click="setArtistReviewed(true)"
                                                            class="radiobtn"
                                                            :class="{selected: asset.artist_reviewed}">
                                                            Yes
                                                        </vs-button>
                                                        <vs-button
                                                            color="primary"
                                                            type="border"
                                                            @click="setArtistReviewed(false)"
                                                            class="radiobtn"
                                                            :class="{selected: !asset.artist_reviewed}">
                                                            No
                                                        </vs-button>
                                                    </div>
                                                </div>
                                                <span class="text-danger text-sm validation-error"
                                                      v-show="errors.has('test')">{{ errors.first('test') }}</span>
                                                <vx-tooltip
                                                    class="help-tip"
                                                    position="right"
                                                    :text="asset.artist_reviewed_by || asset.artist_reviewed_at ? asset.artist_reviewed_by + '</br>' + new Date(asset.artist_reviewed_at).toLocaleString(): 'Default status'"
                                                >
                                                    <i class="material-icons notranslate"> help_outline </i>
                                                </vx-tooltip>
                                            </div>
                                        </vx-input-group>
                                    </div>
                                </div>
                                <vx-input-group class="custom-input-group">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Visibility
                                        </div>
                                    </template>

                                    <div class="d-flex" :class="{'no-edit': $store.state.user.role.name !== 'Academic' && $store.state.user.role.name !== 'Manager'}">
                                        <div class="vx-input-group-append flex-grow">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="setVisibility('internal_only')"
                                                    class="radiobtn"
                                                    :class="{selected: visibility == 'internal_only'}">
                                                    Internal Only
                                                </vs-button>
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="setVisibility('b2b')"
                                                    class="radiobtn"
                                                    :class="{selected: visibility == 'b2b'}">
                                                    B2B
                                                </vs-button>
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="setVisibility('public')"
                                                    class="radiobtn visibility-public-btn"
                                                    :class="{selected: visibility == 'public'}">
                                                    Public
                                                </vs-button>
                                            </div>
                                        </div>
                                        <span class="text-danger text-sm validation-error"
                                              v-show="errors.has('test')">{{ errors.first('test') }}</span>
                                        <vx-tooltip
                                            class="help-tip"
                                            position="right"
                                            :text="asset.visibility_by || asset.visibility_at ? asset.visibility_by + '</br>' + new Date(asset.visibility_at).toLocaleString(): 'Default status'">
                                            <i class="material-icons notranslate"> help_outline </i>
                                        </vx-tooltip>
                                    </div>
                                </vx-input-group>
                                <vx-input-group class="custom-input-group">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Readiness
                                        </div>
                                    </template>

                                    <div class="d-flex" :class="{'no-edit': $store.state.user.role.name !== 'Manager'}">
                                        <div class="vx-input-group-append flex-grow">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="setPublished2(false)"
                                                    class="radiobtn"
                                                    :class="{selected: !asset.published}">
                                                    Draft
                                                </vs-button>
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="setPublished2(true)"
                                                    class="radiobtn published-btn"
                                                    :class="{selected: asset.published}">
                                                    Published
                                                </vs-button>
                                            </div>
                                        </div>
                                        <span class="text-danger text-sm validation-error"
                                              v-show="errors.has('test')">{{ errors.first('test') }}</span>
                                        <vx-tooltip
                                            class="help-tip"
                                            position="right"
                                            :text="asset.published_by || asset.published_at ? asset.published_by + '</br>' + new Date(asset.published_at).toLocaleString(): 'Default status'"
                                        >
                                            <i class="material-icons notranslate"> help_outline </i>
                                        </vx-tooltip>
                                    </div>
                                </vx-input-group>
                                <vx-input-group class="custom-input-group">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                          AR Readiness
                                        </div>
                                    </template>

                                    <div class="d-flex" :class="{'no-edit': $store.state.user.role.name !== 'Manager' && $store.state.user.role.name !== 'AR Publisher'}">
                                        <div class="vx-input-group-append flex-grow">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="setArReviewed(false)"
                                                    class="radiobtn"
                                                    :class="{selected: !asset.ar_reviewed}">
                                                    Draft
                                                </vs-button>
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="setArReviewed(true)"
                                                    class="radiobtn ar-readiness-btn"
                                                    :class="{selected: asset.ar_reviewed}">
                                                    Published
                                                </vs-button>
                                            </div>
                                        </div>
                                        <span class="text-danger text-sm validation-error"
                                              v-show="errors.has('test')">{{ errors.first('test') }}</span>
                                        <vx-tooltip
                                            class="help-tip"
                                            position="right"
                                            :text="asset.ar_reviewed_by || asset.ar_reviewed_at ? asset.ar_reviewed_by + '</br>' + new Date(asset.ar_reviewed_at).toLocaleString(): 'Default status'"
                                        >
                                            <i class="material-icons notranslate"> help_outline </i>
                                        </vx-tooltip>
                                    </div>
                                </vx-input-group>
                            </div>
                        </div>
                        <div class="vx-col w-full sm:w-full md:w-1/3" :class="{'no-edit': $store.state.user.role.name === 'Academic'}">
                            <div class="d-flex justify-end mb-2 align-center">
                                <div class="mr-3">Language</div>
                                <v-select
                                  ref="currentLanguage"
                                  class="hide-search break-word"
                                  name="currentLanguage"
                                  :options="[{ name: 'English', code: 'en' }, ...$store.state.languages]"
                                  v-model="currentLanguage"
                                  label="name"
                                  :searchable="false"
                                  :clearable="false"
                                  style="width: 150px; height: 38px;"
                                  :reduce="item => item"/>
                              <vs-button color="primary" id="sync-translations" class="ml-3" type="gradient" :disabled="asset.is_locked_translations[currentLanguage.code]" @click="syncTranslations">
                                Sync translations
                              </vs-button>
                            </div>
                          <div class="locked-translations mt-4" v-if="$store.state.user.role.name === 'Manager' || $store.state.user.role.name === 'CopyEditors'">
                            <div class="mr-2">Locked translations:</div>
                            <vs-switch color="primary" v-model="asset.is_locked_translations[currentLanguage.code]">
                              <span slot="on">On</span>
                              <span slot="off">Off</span>
                            </vs-switch>
                          </div>
                            <vx-input-group class="custom-input-group">
                                <div class="asset-thumbnail-block">
                                    <div class="asset-thumbnail-section">
                                        <HoverThumb :main="asset.thumbnail" :list="asset.thumbnails" :asset="asset"/>
                                    </div>
                                </div>
                            </vx-input-group>
                            <div class="d-flex justify-center mt-2" v-if="asset._id
                             && asset.published_variant
                             && asset.variants.find(item => item._id === asset.published_variant)">
                                <vs-button color="primary" id="sync-thumbnail-btn" type="gradient" @click="syncThumbnails">
                                    Sync thumbnail
                                </vs-button>
                            </div>

                            <div id="upload-thumb-btn" class="relative">
                                <!--                                <div class="d-flex" v-if="thumbnails.length === 0">-->
                                <!--                                    <vs-button-->
                                <!--                                        class="px-2"-->
                                <!--                                        type="gradient"-->
                                <!--                                        color="#7367F0"-->
                                <!--                                        gradient-color-secondary="#CE9FFC"-->
                                <!--                                        style="flex-grow: 1"-->
                                <!--                                        @click="uploadThumb"-->
                                <!--                                        :class="`download-ready-0 coobo-ready-btn`">Upload thumbnail-->
                                <!--                                    </vs-button>-->
                                <!--                                </div>-->
                                <vx-input-group v-if="thumbnails.length">
                                    <div class="break-word" style="height: 65px;">
                                        <div class="label pr-2 pt-2">
                                            Thumbnails:
                                        </div>
                                        <v-select
                                            ref="thumbDropdown"
                                            class="hide-search break-word thumbs-dropdown"
                                            name="thumbnail"
                                            :options="thumbnails"
                                            :value="asset.thumbnail"
                                            @input="setThumbNail"
                                            label="name"
                                            :searchable="false"
                                            :clearable="false"
                                            :reduce="item => item.thumbnail"/>
                                    </div>
                                </vx-input-group>
                            </div>
                        </div>
                    </div>
                </vx-card>

                <div class="variations-section" :class="{'no-edit': $store.state.user.role.name === 'CopyEditors'}">
                    <div class="dfaicjcsb mb-base">
                        <h3 style="padding-right: 30px">
                  <span class="d-flex relative" style="padding-right: 5px">
                    Variations
                    <vx-tooltip
                        class="help-tip"
                        position="right"
                        text="Use variation to store slightly different take of the same asset. E.g. “High Poly Source”, “Low Poly Animated”, “Quiz version in Hindi”.">
                                <i class="material-icons notranslate"> help_outline </i>
                    </vx-tooltip>
                  </span>
                        </h3>

                        <vs-button color="primary" type="gradient" @click="isAddVariation = true"
                                   v-if="$store.state.user.role.name !== 'Academic' && $store.state.user.role.name !== 'AR Publisher' && asset.variants.length > 0">
                            Add variation
                        </vs-button>
                    </div>
                    <div class="vx-row" style="display: flex; flex-wrap: wrap">
                        <div v-for="(item, index) in asset.variants" :key="index"
                             class="vx-col w-full  sm:w-1/2 lg:w-1/3 xl:w-1/4">
                            <VariantItem
                                :published="currentLanguage.code === 'en' || (!asset.published_variant_langs && !(currentLanguage.code in asset.published_variant_langs)) ? item._id === asset.published_variant :
                                 (asset.published_variant_langs && currentLanguage.code in asset.published_variant_langs) ?
                                  item._id === asset.published_variant_langs[currentLanguage.code] : item._id === asset.published_variant"
                                :isSyncThumbnail="syncVariations[item._id]"
                                :setPublished="setPublished"
                                :cantEditPublished="cantEditPublished"
                                :editMode="$store.state.user.role.name !== 'AR Publisher'"
                                :item="item"
                                :asset="assetData"
                                :index="index"
                                :open-asset-popup="openAssetPopup"
                                :update-asset-thumb="setAssetThumb"
                                :edit="editVariation"
                                :del="deleteElement"
                                :syncVariationThumb="syncVariationThumb"
                                :createQuestion="createQuestion"
                            />
                        </div>
                        <div class="vx-col w-full sm:w-1/2 lg:w-1/3 xl:w-1/4"
                             style="display: flex; justify-content: center; align-items: center;min-height: 380px"
                             v-if="asset.variants.length == 0">
                            <vs-button radius color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                                       class="plus-btn" @click="isAddVariation = true"></vs-button>
                        </div>
                    </div>
                </div>
                <div class="vx-row" :class="{'no-edit': $store.state.user.role.name === 'CopyEditors'}">
                    <div class="vx-col w-full sm:w-full md:w-full" style="z-index: 6;">
                        <vx-card>
                            <div class="dfaicjcsb mb-base">
                                <div class="d-flex align-center">
                                    <h3>Academic metadata</h3>
<!--                                    <div class="d-flex ml-2 align-center pt-1" v-if="$store.state.user.role.name === 'Manager' || $store.state.user.role.name === 'Academic'">-->
<!--                                        (<span class="mr-1">meta auto-search</span>-->
<!--                                        <vs-switch color="primary" v-model="metaSearchEnabled" style="width: 45px">-->
<!--                                            <span slot="on">On</span>-->
<!--                                            <span slot="off">Off</span>-->
<!--                                        </vs-switch>)-->
<!--                                    </div>-->
                                </div>
                                <div v-if="asset && metaKg && metaKg.length">
                                    <v-select :options="$store.state.learningMapFormats"
                                              :reduce="item => item.id"
                                              label="name"
                                              class="ignore-no-edit"
                                              v-model="learningMapFormat"
                                              style="min-width: 300px"
                                    />
                                </div>
                            </div>
                            <MetaSearch
                                ref="kgSearch"
                                url="/metaproxy/search/"
                                :meta-arr="metaKg"
                                :clearOtherSearches="clearOtherSearches"
                                v-if="$store.state.user.role.name !== 'Media'"
                                :addConcepts="addConcepts"
                                :addConcept="addConcept"/>
                            <div>
                            <div id="meta-container" style="min-height: 30px; margin-top: 20px" class="relative">
                                    <table v-if="metaKg && metaKg.length > 0"
                                           class="meta-table mt-3">
                                        <thead>
                                        <th style="width: 7%">Concept</th>
                                        <th style="width: 15%">Title</th>
<!--                                        <th style="width: 3%">Grade</th>-->
                                        <th style="width: 10%">Exam</th>
                                        <th style="width: 10%">Subject</th>
                                        <th style="width: 15%">Unit</th>
                                        <th style="width: 20%">Chapter</th>
                                        <th style="width: 20%">Topic</th>
                                        <th></th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in metaKg" :key="index">
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item.concept_id}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div class="table-input d-flex">
                                                        {{currentLanguage.code !== 'en' ? item['title_' + currentLanguage.code] ? item['title_' + currentLanguage.code] : item.title : item.title}}
                                                      <vx-tooltip
                                                        class="am-tooltip"
                                                        position="bottom"
                                                        :text="item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].map(el2 => el2['goal']).join(', ')"
                                                        v-if="item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && (!item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) || !item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['exam']) && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].map(el2 => el2['goal']).length"
                                                      >
                                                        <div class="am-tooltip-count">{{ item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].map(el2 => el2['goal']).length }}</div>
                                                      </vx-tooltip>
                                                    </div>
                                                </div>
                                            </td>
<!--                                            <td>-->
<!--                                                <div>-->
<!--                                                    <div class="table-input">-->
<!--                                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['grade'] : ''}}-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </td>-->
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['exam'] : ''}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['subject'] : ''}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['unit'] : ''}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['chapter'] : ''}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code] && item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat) ? item[currentLanguage.code === 'en' ? 'learning_map' : 'learning_map_' + currentLanguage.code].find(el => el.lm_format_id == learningMapFormat)['topic'] : ''}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="padding: 5px" v-if="!asset.published && $store.state.user.role.name !== 'Media' || (asset.published && $store.state.user.role.name !== 'Academic')">
                                                <vs-button color="danger" type="gradient" class="action-metadata-btn"
                                                           @click="deleteMeta(item)"
                                                >
                                                    <i translate="translate" class="material-icons notranslate"> clear </i>
                                                </vs-button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                            </div>
                            </div>
                          <div class="mt-5 dfaicjcsb mb-base">
                            <h3>Primary concept</h3>
                          </div>
                          <MetaSearch
                            ref="kgSearch2"
                            url="/metaproxy/search/"
                            :clearOtherSearches="clearOtherSearches"
                            v-if="$store.state.user.role.name !== 'Media'"
                            :addPrimaryConcepts="addPrimaryConcepts"/>
                          <div>
                            <div id="meta-container2" style="min-height: 30px; margin-top: 20px" class="relative" v-if="primaryConcepts && primaryConcepts.length">
                              <table class="meta-table mt-3">
                                <thead>
                                <th style="width: 42%">Concept</th>
                                <th style="width: 55%">Title</th>
                                <th  style="width: 3%"></th>
                                </thead>
                                <tbody>
                                <tr v-for="(primaryConcept, index) in primaryConcepts" :key="index">
                                  <td>
                                    <div>
                                      <div class="table-input">
                                        {{primaryConcept.concept_id}}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <div class="table-input d-flex">
                                        {{primaryConcept.title}}
                                      </div>
                                    </div>
                                  </td>
                                  <td style="padding: 5px" v-if="!asset.published && $store.state.user.role.name !== 'Media' || (asset.published && $store.state.user.role.name !== 'Academic')">
                                    <vs-button color="danger" type="gradient" class="action-metadata-btn"
                                               @click="deletePrimaryConcept(primaryConcept)"
                                    >
                                      <i translate="translate" class="material-icons notranslate"> clear </i>
                                    </vs-button>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </vx-card>
                    </div>
                    <div class="vx-col w-full sm:w-full md:w-full" v-if="false && asset.subject !== 'Generic'"
                         style="z-index: 5;">
                        <vx-card>
                            <div class="dfaicjcsb mb-base">
                                <h3>Academic KGC metadata</h3>
                            </div>
                            <MetaSearch ref="kgcSearch"
                                        url="/metaproxy/searchkgc/"
                                        :meta-arr="this.asset.meta_KGC"
                                        :addConcept="addKGCConcept"
                                        :clearOtherSearches="clearOtherSearches"/>
                            <div>
                                <div id="meta-kgc-container" style="min-height: 30px; margin-top: 20px" class="relative">
                                    <table v-if="asset.meta_KGC && asset.meta_KGC.length > 0"
                                           class="meta-table mt-3">
                                        <thead>
                                        <th>Concept</th>
                                        <th style="width: 70%">Title</th>
                                        <th>KG Code</th>
                                        <th v-if="$store.state.user.role.name === 'Manager'" style="width: 1px;"></th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in asset.meta_KGC" :key="index">
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item.concept_id}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item.title === "kgtitle" ? "" : item.title}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div class="table-input">
                                                        {{item.kg_code}}
                                                    </div>
                                                </div>
                                            </td>
                                            <td v-if="$store.state.user.role.name === 'Manager'" style="padding: 5px">
                                                <vs-button color="danger" type="gradient" class="action-metadata-btn"
                                                           @click="deleteKGCMeta(item)"
                                                >
                                                    <i translate="translate" class="material-icons notranslate"> clear </i>
                                                </vs-button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </vx-card>
                    </div>
                </div>

                <vx-card>
                    <div class="dfaicjcsb mb-base" :class="{'no-edit': $store.state.user.role.name === 'CopyEditors'}">
                        <h3 style="padding-right: 30px">
                  <span class="d-flex relative" style="padding-right: 5px">
                    Related Assets
                    <vx-tooltip
                        class="help-tip"
                        position="right"
                        text="Other assets that are conceptually related to this asset.">
                                <i class="material-icons notranslate"> help_outline </i>
                    </vx-tooltip>
                  </span>
                        </h3>
                        <vs-button color="primary" type="gradient" @click="isAddRelatedAsset = true"
                                   v-if="related_assets.length > 0 && $store.state.user.role.name !== 'Academic'">
                            <!--<i translate="translate" class="material-icons notranslate"> add </i>-->
                            Add related asset
                        </vs-button>
                    </div>
                    <div class="vx-row">
                        <div
                            class="vx-col related-item custom-asset-card mb-base w-full sm:w-1/2 md:w-1/4 lg:w-1/6 xl:w-1/6"
                            v-for="(item, index) in related_assets"
                            :key="index">
                            <AssetItem :item="item">
                                <div class="delete-icon-block" v-if="$store.state.user.role.name === 'Manager'">
                                    <button type="button" class="btn-x-file"
                                            @click.stop.prevent="deleteElement('related_assets', item)">
                                        <i translate="translate" class="material-icons notranslate"> clear </i>
                                    </button>
                                </div>
                            </AssetItem>
                        </div>
                        <div class="vx-col w-full custom-asset-card" v-if="related_assets.length == 0">
                            <div
                                style="display: flex; justify-content: center; align-items: center; height: 100%; min-height: 250px">
                                <vs-button radius color="primary" type="filled" icon-pack="feather" icon="icon-plus"
                                           class="plus-btn" @click="isAddRelatedAsset = true"></vs-button>
                            </div>
                        </div>
                    </div>
                </vx-card>
                <div class="vx-row" :class="{'no-edit': $store.state.user.role.name === 'Academic' || $store.state.user.role.name === 'CopyEditors' || $store.state.user.role.name === 'AR Publisher' || cantEditPublished}">
                    <div class="vx-col w-full sm:w-full md:w-1/2" style="z-index: 4;">
                        <vx-card>
                            <h3 style="margin-bottom: 20px">Sourcing</h3>
                            <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        License Type
                                    </div>
                                </template>

                                <div>
                                    <v-select name="license_type" v-validate="'required'" :options="licenseTypes"
                                              v-model="asset.license_type" :reduce="item => item.name" label="name"/>
                                    <span class="text-danger text-sm validation-error" v-show="errors.has('license_type')">{{ errors.first('license_type') }}</span>
                                </div>
                            </vx-input-group>
                            <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Partner
                                    </div>
                                </template>

                                <div>
                                    <vs-input
                                        name="license_partner"
                                        placeholder="Vida Systems, Kompanion, Designmate, etc"
                                        v-model="asset.license_partner"
                                    />
                                    <span class="text-danger text-sm validation-error"
                                          v-show="errors.has('license_partner')">{{ errors.first('license_partner') }}</span>
                                </div>
                            </vx-input-group>
                            <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Source
                                    </div>
                                </template>

                                <div>
                                    <vs-input
                                        name="license_url"
                                        placeholder="Link to Turbosquid, CGTrader, etc"
                                        v-model="asset.license_url"
                                    />
                                    <span class="text-danger text-sm validation-error" v-show="errors.has('license_url')">{{ errors.first('license_url') }}</span>

                                </div>
                            </vx-input-group>
                            <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Attribution
                                    </div>
                                </template>

                                <div>
                                    <vs-input
                                        name="attribution"
                                        placeholder="For CC-BY content only, person or organization name to be credited"
                                        v-model="asset.attribution_text"
                                    />
                                    <span class="text-danger text-sm validation-error" v-show="errors.has('attribution')">{{ errors.first('attribution') }}</span>
                                </div>
                            </vx-input-group>
                            <vx-input-group class="custom-input-group">
                                <template slot="prepend">
                                    <div class="prepend-text bg-dark">
                                        Price
                                    </div>
                                </template>

                                <div class="custom-input" style="display: flex">
                                    <div class="w-full relative">
                                        <vs-input
                                            name="price"
                                            class="price-input"
                                            placeholder="Price"
                                            v-model="asset.price"
                                        />
                                        <span class="text-danger text-sm validation-error" v-show="errors.has('price')">{{ errors.first('price') }}</span>
                                    </div>
                                </div>
                                <template slot="append">
                                    <div class="append-text btn-addon">
                                        <vs-button
                                            color="primary"
                                            type="border"
                                            v-for="(c, i) in currencies"
                                            :key="i"
                                            @click="asset.currency = c.value"
                                            class="radiobtn"
                                            :class="{selected: asset.currency === c.value}">
                                            {{c.name}}
                                        </vs-button>
                                    </div>
                                </template>
                            </vx-input-group>
                        </vx-card>
                    </div>
                    <div class="vx-col w-full sm:w-full md:w-1/2" style="z-index: 3;">
                        <vx-card>
                            <div style="padding-right: 30px;">
                                <vx-input-group class="custom-input-group">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Notes
                                        </div>
                                    </template>

                                    <div class="d-flex">
                                        <vs-textarea
                                            class="resize-vertical"
                                            name="name"
                                            placeholder="Write your notes..."
                                            v-model="asset.notes"
                                        />
                                        <vx-tooltip
                                            class="help-tip"
                                            position="right"
                                            text="Additional notes that might help with tracking the asset, such as Jira CAC numbers or special instructions">
                                            <i class="material-icons notranslate"> help_outline </i>
                                        </vx-tooltip>
                                    </div>

                                </vx-input-group>
                                <vx-input-group class="custom-input-group">
                                    <template slot="prepend">
                                        <div class="prepend-text bg-dark">
                                            Test
                                        </div>
                                    </template>

                                    <div class="d-flex">
                                        <div class="vx-input-group-append flex-grow">
                                            <div class="append-text btn-addon">
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="asset.is_test = true"
                                                    class="radiobtn"
                                                    :class="{selected: asset.is_test}">
                                                    Yes
                                                </vs-button>
                                                <vs-button
                                                    color="primary"
                                                    type="border"
                                                    @click="asset.is_test = false"
                                                    class="radiobtn"
                                                    :class="{selected: !asset.is_test}">
                                                    No
                                                </vs-button>
                                            </div>
                                        </div>
                                        <span class="text-danger text-sm validation-error"
                                              v-show="errors.has('test')">{{ errors.first('test') }}</span>
                                        <vx-tooltip
                                            class="help-tip"
                                            position="right"
                                            text="If Yes, the asset is considered a temporary testing asset that might be deleted at any time">
                                            <i class="material-icons notranslate"> help_outline </i>
                                        </vx-tooltip>
                                    </div>
                                </vx-input-group>
                            </div>
                        </vx-card>
                    </div>
                </div>
                <add-related-assets v-if="isAddRelatedAsset" v-on:close="isAddRelatedAsset = false"
                                    v-on:addRelatedAssets="addRelatedAssets"
                                    :relatedAssets="related_assets"></add-related-assets>
                <add-variation v-if="isAddVariation" v-on:closeAddVariation="closeAddVariation" :visualStyles="visualStyles"
                               :updateAsset="updateAsset"
                               :asset="asset"
                               :edit_item="editVariationItem"></add-variation>
                <create-question :variant="createQuestionItem" v-on:closeCreateQuestion="closeCreateQuestion" :asset="asset" v-if="isCreateQuestionModal"></create-question>
                <info v-if="isInfoModal" v-on:closeInfo="closeInfoModal"></info>
                <asset-meta :asset="asset" v-if="asset && asset.meta"></asset-meta>
            </div>

              <vs-popup
                  fullscreen title="View asset"
                  :class="['view-asset-popup', (assetPopupActiveIndex || assetPopupActiveIndex === 0) ? 'active' : '']"
                  :active="true"
                  class="iframe-popup" v-on:close="closeViewAsserModal">

                  <template class="iframe-popup position-relative" v-if="assetPopupActiveIndex || assetPopupActiveIndex === 0">
                      <iframe  v-if="asset.asset_type === '3D'" :src="preload(asset.variants[assetPopupActiveIndex])" allowfullscreen="" frameborder="0"/>
                      <img :src="assetPopupData" v-if="asset.asset_type === 'image' || asset.asset_type === 'illustration'"/>
                      <iframe v-if="asset.asset_type === 'vr_image'" allowfullscreen="" frameborder="0" :src="preload(asset.variants[assetPopupActiveIndex])"/>
                      <video v-if="asset.asset_type === 'video' || asset.asset_type === 'animation'" autoplay controls allowfullscreen="" frameborder="0" :src="assetPopupData"/>

                      <div class="audio-cnt">
                          <div class="filename">{{getPreload(asset.variants[assetPopupActiveIndex], 'filename')}}</div>
                          <audio v-if="(assetPopupActiveIndex || assetPopupActiveIndex === 0) && asset.asset_type === 'audio'" autoplay controls :src="getPreload(asset.variants[assetPopupActiveIndex], 'src')"/>
                      </div>

                      <a :href="linkCooboTwo(asset.variants[assetPopupActiveIndex])" target="_blank" style="position:absolute; right: 15%; bottom: 6%;" v-if="asset.asset_type === '3D'">
                          <vs-button type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC" style="width: 100%">Coobo 2</vs-button>
                      </a>
                      <vs-button radius icon-pack="feather" class="close-view-asset"  size="large" icon="icon-plus" @click="closeViewAsserModal"/>
                  </template>
              </vs-popup>
            <vs-popup fullscreen title="View object hierarchy" :active.sync="hierarchyPopupActive" class="iframe-popup">
                <div class="h-100">
                    <ObjectHierarchy v-if="hierarchyPopupActive" :coobo-asset-id="hierarchyPopupId"/>
                </div>
            </vs-popup>
        </template>
        <error404 v-if="isError" :is_page="true"></error404>
        <restore v-if="isRestore" :id="$route.params.id" :getAsset="getAsset"></restore>
        <validation v-if="isValidation && validationData" :updateTranslations="updateTranslations" :invalid="Object.values(validationData.general).findIndex(item => !item) !== -1
                || Object.values(validationData.published_variation[asset.asset_type.toLowerCase() === 'animation' ? 'video' : ['vr_image', 'illustration', 'cg_image'].includes(asset.asset_type.toLowerCase()) ? 'image' : asset.asset_type.toLowerCase()]).findIndex(item => !item) !== -1"
                    :asset="asset" :data="validationData" :asset_type="asset.asset_type" v-on:closeValidaton="closeValidaton"></validation>
        <ar-reviewed-validation v-if="isArReviewedModal" :asset="asset" :data="validationData" :updateTranslations="updateTranslations" :invalid="asset.asset_type.toLowerCase() === '3d' && Object.values(validationData.published_variation[asset.asset_type.toLowerCase()]).findIndex(item => !item) !== -1" v-on:closeArReviewedValidaton="closeArReviewedValidaton"/>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import 'swiper/dist/css/swiper.min.css'
import addRelatedAssets from '../components/modal/addRelatedAssets.vue'
import addVariation from '../components/modal/addVariation.vue'
import addMetaData from '../components/modal/addMetaData.vue'
import customUpload from '../components/customUpload.vue'
import info from '../components/modal/info.vue'
import Error404 from './pages/Error404.vue'
import Restore from './pages/Restore.vue'
import {Validator} from 'vee-validate';
import AssetItem from "../components/AssetItem";
import ObjectHierarchy from "../components/ObjectHierarchy";
import MetaSearch from "../components/MetaSearch";
import HoverThumb from "../components/HoverThumb";
import VariantItem from "../components/VariantItem";
import KGC from "../components/KGC";
import axios from 'axios'
import validation from '../components/modal/validation.vue'
import CreateQuestion from "@/components/modal/createQuestion.vue";
import AssetMeta from "@/components/AssetMeta.vue";
import CustomTags from "@/components/CustomTags.vue";
import ArReviewedValidation from "@/components/modal/arReviewedValidation.vue";

export default {
    name: 'Asset',
    components: {
      ArReviewedValidation,
      CustomTags,
        CreateQuestion,
        addRelatedAssets,
        addVariation,
        HoverThumb,
        info,
        vSelect,
        customUpload,
        addMetaData,
        Error404,
        AssetItem,
        KGC,
        MetaSearch,
        VariantItem,
        ObjectHierarchy,
        Restore,
        validation,
        AssetMeta
    },
    head: {
        title() {
            return {
                inner: 'AMP',
                separator: this.header_separator,
                complement: this.header_component
            }
        },
        meta: [
            {hid: 'description', name: 'description', content: ''}
        ]
    },
    data() {
        return {
            debounce: false,
            isUniqName: false,
            isError: false,
            isRestore: false,
            isLoading: false,
            isDuplicateLoading: false,
            isArReviewedModal: false,
            isValidation: false,
            isChanged: false,
            isSaved: false,
            assetPopupData: "",
            assetPopupActive: false,
            assetPopupActiveIndex: null,
            hierarchyPopupId: "",
            hierarchyPopupActive: false,
            header_separator: ' ',
            header_component: '',
            isAddRelatedAsset: false,
            isAddVariation: false,
            isCreateQuestionModal: false,
            isInfoModal: false,
            asset: null,
            deleteItem: null,
            deleteItemType: null,
            editVariationItem: null,
            createQuestionItem: null,
            editMetadataItem: null,
            types: this.$store.getters.assetTypes,
            video_types: ["Explainer", "Solved Problems", "IRL", "DIY", "Experiments", "Out of syllabus", "Spoof", "Video footage", "Animation"],
            narrators: ["Yes", "No", "Offscreen"],
            currentLanguage: {
              name: 'English',
              code: 'en'
            },
            licenseTypes: [
                {
                    value: "CC0/Public Domain",
                    name: "CC0/Public Domain",
                }, {
                    value: "CC-BY",
                    name: "CC-BY",
                }, {
                    value: "CC-SA",
                    name: "CC-SA",
                }, {
                    value: "CC-ND",
                    name: "CC-ND",
                }, {
                    value: "Embibe Internal",
                    name: "Embibe Internal",
                }, {
                    value: "Purchased",
                    name: "Purchased",
                }, {
                    value: "Editorial Only",
                    name: "Editorial Only",
                },
            ],
            currencies: [
                {
                    value: "USD",
                    name: "USD",
                }, {
                    value: "INR",
                    name: "INR",
                },
            ],
            category: '',
            categories: [],
            subCategories: [],
            visualStyles: [{
                name: 'Abstract'
            }, {
                name: 'Realistic'
            }, {
                name: 'Cartoon'
            }, {
                name: 'Mixed'
            }],
            thumbnails: [],
            related_assets: [],
            uploadData: {},
            concept_id_search: "",
            conceptsLoading: false,
            conceptResults: [],
            selectedConcepts: [],
            cancelConceptSearch: null,
            cDebounce: false,
            self: null,
            metaSearchEnabled: false,
            thumbChanged: false,
            visibility: 'internal_only',
            validationData: null,
            learningMapFormat: '5ec5867a0c88fe5860961943',
            cantEditPublished: false,
            syncVariations: {},
            initTimestamp: null
        }
    },
    mounted() {
        if (this.$route.params.id && !this.$route.params.id.match(/^[0-9a-fA-F]{24}$/)) {
            this.$router.push("/error-404");
            return
        }
        if (this.$store.state.user.role.name === 'CopyEditors' || this.$store.state.user.role.name === 'Media' || this.$store.state.user.role.name === 'AR Publisher' || this.$store.state.user.role.name === 'Manager' || this.$store.state.user.role.name === 'Academic') {
            // this.extendValidator()
            this.getAsset();
            // this.getCategories();
            // this.getSubCategories();
            // this.getVisualStyles();
        } else {
            this.isSaved = true;
            this.$router.push('/');
        }
        this.self = this;
        this.initTimestamp = new Date().getTime();
        // console.log("assetPopupData",assetPopupData);

    },
    methods: {
      setPrimaryTags(tags, lang) {
        if (lang && lang !== 'en') {
          this.asset.locales[lang].primary_tags = tags;
        } else {
          this.asset.primary_keywords = tags;
        }
      },
      setTags(tags, lang) {
        if (lang && lang !== 'en') {
          this.asset.locales[lang].tags = tags;
        } else {
          this.asset.keywords = tags;
        }
      },
        closeViewAsserModal(){
          this.assetPopupActiveIndex=null;
          document.body.classList.remove("overflow-hidden")
        },
        setAcademicReviewed(val) {
            this.asset.academic_reviewed = val;
            this.asset.academic_reviewed_by = this.$store.state.user.email;
            this.asset.academic_reviewed_at = new Date();
            this.asset.published = false;
            this.asset.ar_reviewed = false;
        },
        setArtistReviewed(val) {
            this.asset.artist_reviewed = val;
            this.asset.artist_reviewed_by = this.$store.state.user.email;
            this.asset.artist_reviewed_at = new Date();
            this.asset.published = false;
            this.asset.ar_reviewed = false;
        },
        setArReviewed(val) {
          if (val) {
            if (!this.asset.academic_reviewed) {
              this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error: not academic reviewed', time: 5000});
              return
            }
            if (!this.asset.artist_reviewed) {
              this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error: not artist reviewed', time: 5000});
              return
            }
            if (this.asset.visibility !== 'public') {
              this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error: not public visibility', time: 5000});
              return
            }
            if (!this.asset.published_variant) {
              this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error: starred variant not found', time: 5000});
              return
            }
            // let publishedVariant = this.asset.variants.find(item => item._id === this.asset.published_variant);
            // let arLinksValid = publishedVariant && publishedVariant.ar_links.length;
            // if (!arLinksValid) {
            //   this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error: no Ar ready file', time: 5000});
            //   return
            // }
            if (!this.asset.ar_reviewed && !this.isArReviewedModal) {
              this.$root.addLoading('.ar-readiness-btn');

              let url = '/assets/validation/ar-readiness';

              this.$axios({
                method: 'post',
                url: url,
                data: this.asset
              }).then(res => {
                this.$root.removeLoading('.ar-readiness-btn');
                this.isLoading = false;
                this.validationData = res.data;
                this.isArReviewedModal = true;
              }).catch((err) => {
                console.log(err);
                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: err.message || err})
                this.isLoading = false;
                this.asset.ar_reviewed = false;
                this.$root.removeLoading('.ar-readiness-btn')
              })
            }
          } else {
            this.asset.ar_reviewed = val;
            this.asset.ar_reviewed_by = this.$store.state.user.email;
            this.asset.ar_reviewed_at = new Date();
          }
        },
        closeArReviewedValidaton() {
          this.isArReviewedModal = false
        },
        setPublished2(val) {
            if (this.$store.state.user.role.name !== 'Media') {
              this.asset.published = val;
              this.asset.published_by = this.$store.state.user.email;
              this.asset.published_at = new Date();
            }

            if (val) {
                this.validationPublic();
            }
        },
        setVisibility(type) {
            this.$set(this.asset, 'visibility', type);
            this.$set(this, 'visibility', type);
            this.asset.visibility_by = this.$store.state.user.email;
            this.asset.visibility_at = new Date();
            this.asset.published = false;
            this.asset.ar_reviewed = false;
        },
        validationPublic() {
            this.isLoading = true;
            if (this.$store.state.user.role.name !== 'Media') {
              this.$root.addLoading('.published-btn');
            }

            let url = '/assets/validation/public';

            let data = Object.assign({}, this.asset, {disableMetaSearch: !this.metaSearchEnabled})
            this.$axios({
                method: 'post',
                url: url,
                data: data
            }).then(res => {
                this.$root.removeLoading('.published-btn');
                this.isLoading = false;
                if (res.data.thumbnail) {
                  this.asset.thumbnail = res.data.thumbnail
                }
                if (res.data.thumbnails) {
                  this.asset.thumbnails = res.data.thumbnails
                }
                this.validationData = res.data;
                this.isValidation = true;
            }).catch((err) => {
                console.log(err);
                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: err.message || err})
                this.isLoading = false;
                this.asset.published = false;
                this.$root.removeLoading('.published-btn')
            })
        },
        closeValidaton() {
            this.isValidation = false;
            if (Object.values(this.validationData.general).findIndex(item => !item) !== -1
                || Object.values(this.validationData.published_variation[this.asset.asset_type.toLowerCase() === 'animation' ? 'video' : (this.asset.asset_type.toLowerCase() === 'vr_image' || this.asset.asset_type.toLowerCase() === 'illustration') ? 'image' : this.asset.asset_type.toLowerCase()]).findIndex(item => !item) !== -1) {
                this.asset.published = false;
            } else {
              let v = this.asset.variants.find(item => item._id === this.asset.published_variant);
              if (v && v.thumbnail && this.asset.thumbnail !== v.thumbnail) {
                this.asset.thumbnail = v.thumbnail;
              }
            }
            this.validationData = null;
        },
        getKeyByValue(object, value, lang) {
          return Object.keys(object).filter(item => item !== lang).find(key => object[key] === value);
        },
        clearifyPublishedVariants(id, lang = 'en') {
          let key = this.getKeyByValue(this.asset.published_variant_langs, id, lang);
          if (key) {
            this.asset.published_variant_langs[key] = "";
          }
        },
        setPublished(item) {
          let id = item._id;
          if (!this.cantEditPublished) {
            if (this.currentLanguage.code === 'en') {
              if (!item.language || item.language === 'none' || item.language === 'en') {
                if (!this.asset.published_variant || this.asset.published_variant && id && this.asset.published_variant !== id) {
                  this.asset.published_variant = this.asset.published_variant === id ? "" : id;
                  this.asset.published = false;
                  this.asset.ar_reviewed = false;
                  this.clearifyPublishedVariants(id);
                }
              } else {
                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: `Variation language(${item.language}) doesn't match with current language(${this.currentLanguage.code})`})
              }
            } else {
              if (this.asset.published_variant === id) {
                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'This variant selected for english language'})
              } else {
                if (!this.asset.published_variant_langs) {
                  this.asset.published_variant_langs = {};
                }
                if (!item.language || item.language === 'none') {
                  this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Variation doesn\'t have language'})
                } else {
                  if (item.language === this.currentLanguage.code) {
                    this.asset.published_variant_langs[this.currentLanguage.code] = this.asset.published_variant_langs[this.currentLanguage.code] === id ? "" : id;
                    this.asset.published = false;
                    this.clearifyPublishedVariants(id, this.currentLanguage.code);
                  } else {
                    this.$vs.notifyWrapper({color: 'danger', fixed: true, title: `Variation language(${item.language}) doesn't match with current language(${this.currentLanguage.code})`})
                  }
                }
              }
            }
            this.$forceUpdate();
          }
        },
        syncTranslations() {
          this.$root.addLoading('#sync-translations');
          let url = '/sync-translations/' + this.asset._id;

          this.$axios.get(url).then(res => {
            if (res.data.error) {
              this.$vs.notifyWrapper({color: 'danger', fixed: true, title: `Translations is locked`, text: 'Save asset before update translations'})
            } else {
              this.$set(this.asset, 'locales', res.data);
              this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Successfully updated'})
            }

            this.$root.removeLoading('#sync-translations');
          }).catch(e => {
            console.log('catch_search', e)
            this.$root.removeLoading('#sync-translations');
          })
        },
        syncThumbnails() {
            this.$root.addLoading('#sync-thumbnail-btn');
            let url = '/assets/' + this.asset._id + '/sync-thumbnails';
            url += '?published_variant=' + this.asset.published_variant;

            this.$axios.get(url).then(res => {
                if (res.data && res.data.status === 'success') {
                  if (res.data.thumbnail) {
                    this.asset.thumbnail = res.data.thumbnail;
                  }
                  if (res.data.thumbnails && Array.isArray(res.data.thumbnails)) {
                    this.asset.thumbnails = res.data.thumbnails;
                  }

                  if (res.data.vThumbs) {
                    for (let k in res.data.vThumbs) {
                      let vIndex2 = this.asset.variants.findIndex(item => item._id === k);
                      if (vIndex2 !== -1) {
                        this.asset.variants[vIndex2].thumbnail = res.data.vThumbs[k];
                      }
                    }
                  }
                  let vIndex = this.asset.variants.findIndex(item => item._id === this.asset.published_variant);
                  if (vIndex !== -1) {
                    if (res.data.thumbnail) {
                      this.asset.variants[vIndex].thumbnail = res.data.thumbnail;
                    }
                    if (res.data.thumbnails && Array.isArray(res.data.thumbnails)) {
                      this.asset.variants[vIndex].thumbnails = res.data.thumbnails;
                    }
                  }

                  this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Successfully updated'})
                } else {
                    this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: 'Save asset in coobo to generate thumbnails'})
                }

                this.$root.removeLoading('#sync-thumbnail-btn');
            }).catch(e => {
                console.log('catch_search', e)
                this.$root.removeLoading('#sync-thumbnail-btn');
            })
        },
        preload(data) {
            let ready_links = data.ready_links ? data.ready_links : [];
            let source_links = data.source_links ? data.source_links : [];
            switch (this.asset.asset_type) {
                case "3D": {
                  if (data.coobo_library_link) {
                    let u = `${data.coobo_library_link}?hq&variation_id=${data._id}`;
                    if (this.$store.state.user.role.name !== 'Media' && this.$store.state.user.role.name !== 'Manager') {
                      u += '&no-edit=true'
                    }
                    return u;
                  }
                  break;
                }
                case "image":
                case "illustration": {
                    let images = [...ready_links, ...source_links].filter(l => l.mime && l.mime.indexOf("image") !== -1)
                    if (images[0] && images[0].url) return images[0].url;
                    break;
                }
                case "vr_image": {
                    let images = ready_links.filter(l => l.mime && l.mime.indexOf("image") !== -1)
                    if (images[0] && images[0].url) return `/panorama-viewer/viewer.html?panorama=${images[0].url}&autoLoad=true&autoRotate=2`;
                    break;
                }
                case "video":
                case "animation": {
                    let videos = [...ready_links, ...source_links].filter(l => l.mime && l.mime.indexOf("video") !== -1)
                    if (videos[0] && videos[0].url) return videos[0].url;
                    break;
                }
                case "audio": {
                    let audios = [...ready_links, ...source_links].filter(l => l.mime && l.mime.indexOf("audio") !== -1)
                    if (audios[0] && audios[0].url) return {src: audios[0].url, filename: `${audios[0].name}${audios[0].ext}`};
                    break;
                }
                default: {
                    return null;
                }
            }
            return false;
        },
        getPreload(item, type) {
            let temp = this.preload(item);
            return temp[type];
        },
        linkCooboTwo(item){
            if(!item.coobo_library_link) return
            let id = item.coobo_library_link.split('/').pop()
            return `https://blob-jiocdn.embibe.com/coobo/teach_lite_3d_viewer_test/lite.html?id=asset-${id}`
        },
        clearOtherSearches(component) {
            Object.values(this.$refs).filter(r => r.componentName === component.componentName && r !== component).forEach((ref) => {
                typeof ref.clearConceptSearch === "function" && ref.clearConceptSearch();
            });
        },
        setAssetThumb(thumb) {
            this.asset.thumbnail = thumb;
            this.thumbChanged = true;
        },
        openAssetPopup(data, index) {
            this.assetPopupData = data;
            this.assetPopupActive = true;
            this.assetPopupActiveIndex = index;
            document.body.classList.add("overflow-hidden")
        },
        openHierarchyPopup(src) {
            this.hierarchyPopupId = src.split("/").pop().split("?")[0];
            this.hierarchyPopupActive = true;
        },
        extendValidator() {
            if (!this.$route.params.id) {
                const isUnique = value =>
                    new Promise(resolve => {
                        this.isLoading = true;
                        this.$root.addLoading('#save-asset-btn');
                        clearTimeout(this.debounce);
                        this.debounce = setTimeout(() => {
                            let url = '/assets/check-name?name=' + value;
                            if (this.asset._id) {
                                url += '&id=' + this.asset._id;
                            }

                            this.$axios({
                                method: 'get',
                                url: url
                            }).then(res => {
                                this.$root.removeLoading('#save-asset-btn');
                                this.isLoading = false;

                                if (!res.data) {
                                    resolve({
                                        valid: true
                                    });
                                } else {
                                    let msg = 'This asset already exists';

                                    if (res.data && res.data != 'invalid') {
                                        msg += ', <a href="/' + res.data + '/edit" target="_blank">click here to view</a>'
                                    }
                                    resolve({
                                        valid: false,
                                        data: {
                                            message: msg
                                        }
                                    });
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.isLoading = false;
                                this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: err.message || err})
                                this.$root.removeLoading('#save-asset-btn')
                            })
                        }, 1000)
                    });
                Validator.extend("unique", {
                    validate: isUnique,
                    getMessage: (field, params, data) => data.message
                });
            }
        },
        setThumbNail(thumb) {
          this.asset.thumbnail = thumb;
          this.thumbChanged = true;
        },
        uploadThumb() {
            let input = document.createElement("input");
            input.type = "file";
            input.accept = ".jpg, .jpeg, .png, .gif";
            input.click();
            input.addEventListener("change", (e) => {
                this.$root.addLoading('#upload-thumb-btn');
                let thumb = e.target.files[0];
                let formData = new FormData();
                formData.append("files", thumb);
                this.$axios.post('/' + this.$store.state.filesUrl, formData).then(res => {
                    if (res.data && res.data[0]) {
                        let thumb = res.data[0].formats && res.data[0].formats.small ? res.data[0].formats.small.url : res.data[0].url;
                        this.thumbnails.push({thumbnail: thumb, name: res.data[0].name, list: []})
                        this.asset.thumbnail = thumb;
                        this.asset.thumbnails = [];
                        this.thumbChanged = true;
                        let tempImg = new Image();
                        tempImg.onload = () => {
                            this.$root.removeLoading('#upload-thumb-btn');
                            tempImg.remove();
                        }
                        tempImg.src = thumb;
                    }
                }).catch(err => {
                  this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: err.message || err})
                  this.$root.removeLoading('#upload-thumb-btn');
                })
                input.remove();
            })
        },
        handleCreatedTag(map, vm, key, lang) {
            const create = (e) => {
                e.preventDefault();
                let items = lang ? this.asset.locales[lang][key] : this.asset[key];
                // items.push(...vm.search.replace(/"/g, "").split(",").map(t => t.trim()).filter(t => t && items.indexOf(t) === -1))
                items.push(vm.search.replace(/"/g, ""));
                vm.search = "";
                setTimeout(() => {
                    vm.searchEl.focus()
                }, 100)
                key === "keywords" && this.metaSearchEnabled && this.getAssetMeta()
                key === "keywords" && this.getRelatedAssets(this.asset);
            }
            console.log(1)
            map[13] = create
            // map[188] = create
            return map;
        },
        onTagChange() {
            this.metaSearchEnabled && this.getAssetMeta()
            this.getRelatedAssets(this.asset);
        },
        deleteKGCMeta(item) {
            // const deleteMeta = () => {
            let manualInd = this.asset.meta_manual_KGC.indexOf(item.uuid)
            if (manualInd !== -1) {
                this.asset.meta_manual_KGC.splice(manualInd, 1);
            } else {
                this.asset.meta_deleted_KGC.push(item.uuid)
            }
            this.asset.meta_KGC.splice(this.asset.meta_KGC.indexOf(item), 1);
            // };
            // this.$vs.dialog({
            //     type: 'confirm',
            //     color: 'danger',
            //     title: `Are you sure you want to delete this meta?`,
            //     text: 'This is a permanent and irreversible action.',
            //     accept: deleteMeta
            // })
        },
        deleteMeta(item) {
            // const deleteMeta = () => {
            this.asset.meta_KGC.filter(kgc => kgc.kg_code === item.concept_id).forEach((kgc) => {
                this.deleteKGCMeta(kgc);
            })
            let manualInd = this.asset.meta_manual.indexOf(item.uuid)
            if (manualInd !== -1) {
                this.asset.meta_manual.splice(manualInd, 1);
            } else {
                this.asset.meta_deleted.push(item.uuid)
            }
            this.asset.meta_KG.splice(this.asset.meta_KG.indexOf(item), 1);
            // };
            // this.$vs.dialog({
            //     type: 'confirm',
            //     color: 'danger',
            //     title: `Are you sure you want to delete this meta?`,
            //     text: 'This is a permanent and irreversible action.',
            //     accept: deleteMeta
            // })
        },
        deletePrimaryConcept(primaryConcept) {
          this.asset.primary_concepts.splice(this.asset.primary_concepts.findIndex(item => item.concept_id === primaryConcept.concept_id), 1);
        },
        addSelectedConcepts() {
            if (!this.selectedConcepts.length) {
                return;
            }
            this.selectedConcepts.forEach(this.addConcept)
            this.clearConceptSearch();
        },
        addKGCConcept(concept) {
            if (this.asset.meta_deleted_KGC.indexOf(concept.uuid) !== -1) {
                this.asset.meta_deleted_KGC.splice(this.asset.meta_deleted_KGC.indexOf(concept.uuid), 1)
            } else {
                this.asset.meta_manual_KGC.push(concept.uuid)
            }
            this.asset.meta_KGC.splice(0, 0, concept);
        },
        addConcepts(concepts) {
            let promises = [];
            for (let k in concepts) {
                promises.push(this.$axios.get(`/get-learning-map/${concepts[k].concept_id}`).catch(e => {
                    console.log('catch_search', e)
                }))
            }
            Promise.all(promises).then(res => {
                for (let k in res) {
                    for (let k2 in concepts) {
                        let concept = concepts[k2];
                        if (concept.concept_id === res[k].data.concept_id) {
                            for (let k2 in res[k].data.data) {
                              concept['learning_map' + (k2 === 'en' ? '' : '_' + k2)] = res[k].data.data[k2];
                            }
                            if (res[k].data.book_kve_codes) {
                              concept.book_kve_codes = res[k].data.book_kve_codes;
                            }

                            this.addConcept(concept);
                        }
                    }
                }
                this.$refs.kgSearch.clearConceptSearch();
            })
        },
        addPrimaryConcept(concept) {
          this.asset.primary_concept = concept;
          this.$refs.kgSearch2.clearConceptSearch();
        },
        addPrimaryConcepts(concepts) {
          let promises = [];
          for (let k in concepts) {
            promises.push(this.$axios.get(`/get-learning-map/${concepts[k].concept_id}`).catch(e => {
              console.log('catch_search', e)
            }))
          }
          Promise.all(promises).then(res => {
            for (let k in res) {
              for (let k2 in concepts) {
                let concept = concepts[k2];
                if (concept.concept_id === res[k].data.concept_id) {
                  for (let k2 in res[k].data.data) {
                    concept['learning_map' + (k2 === 'en' ? '' : '_' + k2)] = res[k].data.data[k2];
                  }
                  if (res[k].data.book_kve_codes) {
                    concept.book_kve_codes = res[k].data.book_kve_codes;
                  }

                  this.asset.primary_concepts.push(concept);
                }
              }
            }
            this.$refs.kgSearch2.clearConceptSearch();
          })
        },
        addConcept(concept) {
            if (this.asset.meta_deleted.indexOf(concept.uuid) !== -1) {
                this.asset.meta_deleted.splice(this.asset.meta_deleted.indexOf(concept.uuid), 1)
            } else {
                this.asset.meta_manual.push(concept.uuid)
            }
            this.asset.meta_KG.splice(0, 0, concept);
            if (concept.KGC && concept.KGC.length) {
                concept.KGC.filter(kgc => this.asset.meta_KGC.map(c => c.concept_id).indexOf(kgc.concept_id) === -1).forEach(kgc => {
                    this.addKGCConcept(kgc)
                })
                delete concept.KGC
            }
        },
        clearConceptSearch() {
            this.conceptResults = [];
            this.concept_id_search = "";
            if (this.cancelConceptSearch && this.cancelConceptSearch.cancel) {
                this.cancelConceptSearch.cancel({err: "Operation canceled by user action."});
            }
        },
        fetchOptions(search) {
            if (search.length < 3) return;
            clearTimeout(this.cDebounce);
            this.cDebounce = setTimeout(() => {
                this.conceptResults = [];
                if (this.cancelConceptSearch && this.cancelConceptSearch.cancel) {
                    this.cancelConceptSearch.cancel({err: "Operation canceled by new search.", newSearch: true});
                }
                this.conceptsLoading = true;
                this.cancelConceptSearch = axios.CancelToken.source();
                this.$axios.get(`/metaproxy/search/${search}`, {cancelToken: this.cancelConceptSearch.token}).then(res => {
                    if (res.data && res.data.length) {
                        this.conceptResults = res.data.filter(c => this.asset.meta_KG.map(m => m.concept_id).indexOf(c.code) === -1).map(c => Object.assign(c, {label: c.code + " " + c.title}));
                    }
                    this.conceptsLoading = false;
                    this.cancelConceptSearch = null;
                }).catch(e => {
                    console.log('catch_search', e)
                    this.conceptResults = [];
                    this.conceptsLoading = Boolean(e.message.newSearch);
                    this.cancelConceptSearch = null;
                })
            }, 500)
        },
        changeUploadImages() {
            this.$root.addLoading('#edit-asset-update-btn');
        },
        updateHead() {
            this.header_component = this.asset.title
            this.header_separator = '-'
            this.$emit('updateHead')
        },
        setThumbDropdownOpts() {
            let asset = this.asset;
            this.thumbnails = asset.variants.filter(item => item.name && item.thumbnail).map(v => ({
                thumbnail: v.thumbnail,
                list: v.thumbnails || [],
                name: 'Variant_' + v.name
            }))
            if (asset.thumbnail && asset.thumbnail.length > 0 && this.thumbnails.map(t => t.thumbnail).indexOf(asset.thumbnail) === -1) {
                this.thumbnails.push({
                    thumbnail: asset.thumbnail,
                    list: asset.thumbnails || [],
                    name: asset.thumbnail.split("/").pop()
                })
            }
        },
        getAssetMeta() {
          return 0;
        },
        getRelatedAssets(asset) {
            asset = asset || this.asset;
            let relatedAssets = this.asset.related_assets || [];
            let excluded = this.asset.related_assets_excluded || [];
            let title = this.asset.title
            let asset_type = this.asset.asset_type
            let description = this.asset.description
            excluded = excluded.slice();
            excluded.push(this.asset._id);
            let keywords = this.asset.keywords;
            this.$axios.post("/related-assets", {
                keywords,
                relatedAssets,
                excluded,
                title,
                description,
                asset_type
            }).then(res => {
                this.related_assets = res.data;
            }).catch(e => {
                console.error('catch_related', e.message)
            })
        },
        getAsset(assetId) {
            let id = assetId ? assetId : this.$route.params.id;

            if (id) {
                let url = '/assets/' + id;

                this.$axios.get(url).then(res => {
                    this.updateStateAsset(res.data);
                }).catch(e => {
                    console.log('catch', e)
                    if (this.$store.state.user.role.name === 'Manager') {
                        this.getDeletedAsset();
                    } else {
                        this.isError = true;
                        document.querySelector('.content-wrapper').classList.add('custom-content-wrapper2')
                    }
                })
            } else {
                let locales = {};
                for (let k in this.$store.state.languages) {
                    locales[this.$store.state.languages[k].code] = {
                        name: '',
                        description: '',
                        primary_tags: [],
                        tags: []
                    }
                }
                let res = {
                    "animated": true,
                    "asset_id": "",
                    "asset_type": "3D",
                    "attribution_text": "",
                    "category": "",
                    "description": "",
                    "primary_keywords": [],
                    "keywords": [],
                    "license_partner": "",
                    "license_type": "Embibe Internal",
                    "license_url": "",
                    "price": "",
                    "currency": "USD",
                    "related_assets": [],
                    "meta_deleted": [],
                    "meta_manual": [],
                    "sub-category": "",
                    "thumbnail": "",
                    "title": "",
                    "visual_style": "",
                    "published_variant": "",
                    "variants": [],
                    "meta_KG": [],
                    "meta_KGC": [],
                    "meta_deleted_KGC": [],
                    "meta_manual_KGC": [],
                    "is_test": false,
                    "academic_reviewed": false,
                    "artist_reviewed": false,
                    "ar_reviewed": false,
                    "primary_concepts": [],
                    "visibility": "internal_only",
                    "locales": locales,
                    "published_variant_langs": {},
                    "is_locked_translations": [{ name: 'English', code: 'en' }, ...this.$store.state.languages].reduce((acc, v) => {
                      acc[v.code] = false;
                      return acc;
                    }, {})
                };

                this.asset = res;
                this.metaSearchEnabled = false;
            }
        },
        updateStateAsset(data) {
          data.keywords = [...new Set(data.keywords)]
          data.primary_keywords = [...new Set(data.primary_keywords)]
          this.isError = false;
          this.isRestore = false;
          document.querySelector('.content-wrapper').classList.remove('custom-content-wrapper2')
          let d = data;
          if (!d.visibility) {
            d.visibility = 'internal_only';
          } else {
            d.visibility = data.visibility ? data.visibility : 'internal_only'
            this.visibility = data.visibility ? data.visibility : 'internal_only'
          }
          if (!d.primary_concepts) {
            d.primary_concepts = [];
          }
          if (!d.artist_reviewed) {
            d.artist_reviewed = false;
          }
          if (!d.ar_reviewed) {
            d.ar_reviewed = false;
          }
          if (!d.academic_reviewed) {
            d.academic_reviewed = false;
          }
          if (!d.published_variant) {
            d.published_variant = '';
          }
          if (!d.published_variant_langs) {
            d.published_variant_langs = {};
          }
          if (!d.is_locked_translations || typeof d.is_locked_translations === 'string' || typeof d.is_locked_translations === 'boolean') {
            d.is_locked_translations = [{ name: 'English', code: 'en' }, ...this.$store.state.languages].reduce((acc, v) => {
              acc[v.code] = false;
              return acc;
            }, {})
          }
          let locales = {};
          for (let k in this.$store.state.languages) {
            if (d.locales && d.locales[this.$store.state.languages[k].code]) {
              locales[this.$store.state.languages[k].code] = {
                name: d.locales[this.$store.state.languages[k].code].name,
                description: d.locales[this.$store.state.languages[k].code].description,
                primary_tags: [...new Set(d.locales[this.$store.state.languages[k].code].primary_tags)],
                tags: [...new Set(d.locales[this.$store.state.languages[k].code].tags)]
              };
            } else {
              locales[this.$store.state.languages[k].code] = {
                name: '',
                description: '',
                primary_tags: [],
                tags: []
              }
            }
          }
          d.locales = locales;
          this.asset = d;
          if (this.$store.state.user.role.name !== 'Manager' && this.$store.state.user.role.name !== 'CopyEditors' && this.asset.published) {
            this.cantEditPublished = true;
          }
          if (["image", "illustration"].indexOf(d.asset_type) !== -1 && d.published_variant && d.variants) {
            let pv = d.variants.find(item => item._id.toString() === d.published_variant.toString());
            if (pv && pv.ready_links && pv.ready_links[0] && (pv.ready_links[0].size / 1024) > 3) {
              this.$vs.notifyWrapper({color: 'warning', fixed: true, title: "Coobo-ready file is >3mb. This can cause performance issues and you won't be able to publish the asset"})
            }
          }

          this.metaSearchEnabled = !data.disableMetaSearch;
          this.setThumbDropdownOpts();
          this.uploadData = {
            ref: 'Asset',
            refId: this.asset._id,
            field: 'thumbnail'
          };
          if (this.metaSearchEnabled && (!data.meta_KG || !data.meta_KG.length)) {
            this.getAssetMeta()
          }
          this.getRelatedAssets(this.asset);
          if (this.asset.notes && this.asset.notes.length) {
            this.asset.notes = this.asset.notes.replace(/&amp;#13;&amp;#10;|&#13;&#10;/g, "\n")
            this.asset.notes = this.asset.notes.replace(/,+/g, ",")
          }
          this.updateHead();
          if (this.$route.query.variation) {
            let item = null;
            for (let k in this.asset.variants) {
              if (this.asset.variants[k]._id === this.$route.query.variation) {
                item = this.asset.variants[k];
                break;
              }
            }
            if (item) {
              this.editVariation(item)
            }
          }
        },
        getDeletedAsset() {
            let id = this.$route.params.id;
            let url = '/deleted-assets/' + id;
            document.querySelector('.content-wrapper').classList.add('custom-content-wrapper2')

            this.$axios.get(url).then(res => {
                this.isRestore = true;
            }).catch(e => {
                this.isError = true;
                console.log('catch_search', e)
            })
        },
        getCategories() {
            let url = '/categories';

            this.$axios.get(url).then(res => {
                this.categories = res.data;
            }).catch(e => {
                console.log('getCategories', e)
            })
        },
        getSubCategories() {
            let url = '/sub-categories';

            this.$axios.get(url).then(res => {
                this.subCategories = res.data;
            }).catch(e => {
                console.log('getCategories', e)
            })
        },
        getVisualStyles() {
            let url = '/visual-styles';

            this.$axios.get(url).then(res => {
                this.visualStyles = res.data;
            }).catch(e => {
                console.log('getCategories', e)
            })
        },
        addRelatedAssets(data) {
            if (data) {
                if (!this.asset.related_assets) {
                    this.asset.related_assets = [];
                }
                data.forEach(a => {
                    let delInd = this.asset.related_assets_excluded.indexOf(a._id);
                    if (delInd !== -1) {
                        this.asset.related_assets_excluded.splice(delInd, 1);
                    }
                })
                let related = data.filter(item => this.related_assets.map(a => a._id).indexOf(item._id) === -1 && item._id !== this.asset._id)
                this.related_assets.push(...related);
                this.asset.related_assets.push(...related.map(a => a._id));
            }
        },
        closeAddVariation(data) {
            if (data) {
                let found = null;
                for (let i = 0; i < this.asset.variants.length; i++) {
                    if (this.asset.variants[i]._id === data.item._id) {
                        found = i;
                        break;
                    }
                }
                if (found === null) {
                    this.asset.variants.push(data.item);
                } else {
                    this.asset.variants[found] = data.item;
                }
            }
            this.editVariationItem = null;
            this.isAddVariation = false;
        },
        closeCreateQuestion(cg_question_id) {
          console.log(cg_question_id)
          if (cg_question_id) {
            let vIndex = this.asset.variants.findIndex(item => item._id === this.createQuestionItem._id);
            if (vIndex !== -1) {
              this.asset.variants[vIndex].cg_question_id = cg_question_id;
            }
          }

          this.createQuestionItem = null;
          this.isCreateQuestionModal = false;
        },
        closeInfoModal(data) {
            if (data) {
                if (this.deleteItemType !== 'related_assets') {
                    this.$root.addLoading('#edit-asset-update-btn');

                    let url = '/';
                    if (this.deleteItemType === 'meta_KG') {
                        url += 'academic-metadata'
                    } else {
                        url += 'variants'
                    }

                    url += '/' + this.asset[this.deleteItemType][this.deleteItemIndex].id

                    this.$axios.delete(url)
                        .then((res) => {
                            this.$root.removeLoading('#edit-asset-update-btn');
                            if ((res.data && res.data.asset) || this.deleteItemType !== 'meta_KG') {
                                this.asset.published_variant = (res.data && res.data.asset) ? res.data.asset.published_variant : null
                            }

                            this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Successfully deleted'})
                        }).catch(e => {
                            this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Error', text: e.message || e})
                            this.$root.removeLoading('#edit-asset-update-btn');
                    })
                    this.asset[this.deleteItemType].splice(this.deleteItemIndex, 1);
                } else {
                    if (this.asset.related_assets.indexOf(this[this.deleteItemType][this.deleteItemIndex]._id) === -1) {
                        this.asset.related_assets_excluded.push(this[this.deleteItemType][this.deleteItemIndex]._id)
                    } else {
                        this.asset[this.deleteItemType].splice(this.deleteItemIndex, 1);
                    }
                }

                if (this[this.deleteItemType]) {
                    this[this.deleteItemType].splice(this.deleteItemIndex, 1);
                }
            }

            this.deleteItemIndex = null;
            this.deleteItemType = null;
            this.isInfoModal = false;
        },
        editVariation(item) {
            this.editVariationItem = item;
            this.isAddVariation = true;
        },
        deleteElement(item, type) {
            this.deleteItemIndex = this.asset[type].indexOf(item);
            this.deleteItemType = type;
            this.isInfoModal = true;
        },
        syncVariationThumb(item) {
          this.$set(this.syncVariations, [item._id], true);
          this.$axios.post("/assets/sync-variation-thumbnails", {
            id: item._id,
            asset_type: this.asset.asset_type
          }).then(res => {
            if (res.data.status === 'error') {
              this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Sync thumbnail error'})
            } else {
              let v = this.asset.variants.find(el => el._id === item._id);
              if (res.data.thumbnail) {
                v.thumbnail = res.data.thumbnail;
              }
              if (res.data.thumbnails) {
                v.thumbnails = res.data.thumbnails;
              }
            }

            this.$set(this.syncVariations, [item._id], false);
          }).catch(e => {
            console.error('catch_related', e.message)

            this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Sync thumbnail error'})
          })
        },
        createQuestion(item) {
            this.createQuestionItem = item;
            this.isCreateQuestionModal = true;
        },
        deleteAsset() {
            const deleteAsset = () => {
                this.$axios.delete('/assets/' + this.$route.params.id).finally(() => {
                    this.isSaved = true;
                    this.$router.push("/")
                })
            };
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Are you sure you want to delete this asset?`,
                text: 'This is a permanent and irreversible action.',
                accept: deleteAsset
            })
        },
        duplicateAsset() {
            const duplicateAsset = () => {
                this.isDuplicateLoading = true;
                this.$axios.get('/assets/' + this.$route.params.id + '/duplicate').then((res) => {
                    this.isSaved = true;
                    this.isDuplicateLoading = false;

                    this.$router.push("/" + res.data._id + '/edit')
                })
            };
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Are you sure you want to duplicate this asset?`,
                accept: duplicateAsset
            })
        },
        updateAsset(opts = {}) {
            this.$validator.validateAll().then(result => {
                if (result || opts.force) {
                    this.isLoading = true;
                    this.$root.addLoading('#save-asset-btn');

                    let id = this.$route.params.id;
                    let url = '/assets';
                    if (id) {
                        url += '/' + id;
                    }
                    this.asset.title = this.asset.title || "Unnamed asset";
                    let data = Object.assign({}, this.asset, {disableMetaSearch: !this.metaSearchEnabled})
                    if (!data.price) {
                        data.price = '';
                    }
                    if (opts.variants) {
                        data.variants = opts.variants;
                    }
                    if (!this.thumbChanged) {
                        delete data.thumbnail;
                        delete data.thumbnails;
                    }
                    if (data.hasOwnProperty('thumbnail') && !this.thumbChanged) {
                        delete data.thumbnail;
                    }
                    if (data.hasOwnProperty('thumbnails')) {
                        delete data.thumbnails;
                    }
                    if (data.hasOwnProperty('meta_KGC')) {
                      delete data.meta_KGC;
                    }
                    if (data.hasOwnProperty('meta_kve_codes')) {
                      delete data.meta_kve_codes;
                    }
                    if (data.hasOwnProperty('meta_lm_codes')) {
                      delete data.meta_lm_codes;
                    }
                    data.timeSpent = new Date().getTime() - this.initTimestamp;

                    const updateAssetRequest = () => {
                      const updateAssetData = (assetData, {onlyUpdateData = 'false'} = {}) => {
                        return this.$axios({
                          method: id ? 'put' : 'post',
                          url: `${url}?onlyUpdateData=${onlyUpdateData}`,
                          data: assetData
                        })
                      }
                      let { meta_KG: assetMetakg } = data;
                      delete data.meta_KG;
                      let promises = [updateAssetData(data)];
                      if (assetMetakg && assetMetakg.length) {
                        promises.push(updateAssetData({meta_KG: assetMetakg}, {onlyUpdateData: "true"}))
                      }
                      Promise.all(promises).then(res => {
                        let resData = (res.shift()).data;
                        if (opts.forceUpdateAsset) {
                          this.updateStateAsset(resData);
                        }
                        this.$root.removeLoading('#save-asset-btn');
                        this.isLoading = false;
                        this.$vs.notifyWrapper({
                          color: 'success',
                          fixed: true,
                          title: id ? 'Updated Successfully' : 'Successfully created'
                        })
                        this.isSaved = true;
                        if (!opts.noRedirect) {
                          this.$router.push(`/${resData._id}`);
                        } else {
                          resData.keywords = [...new Set(resData.keywords)]
                          resData.primary_keywords = [...new Set(resData.primary_keywords)]
                          this.asset = resData;
                        }
                        if (opts.cb && typeof opts.cb === "function") {
                          opts.cb(resData);
                        }
                      }).catch((e) => {
                        console.log(`updateAssetRequest; error: ${e.message}`)
                        this.isLoading = false;
                        this.$root.removeLoading('#save-asset-btn')
                        this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Validation error', text: 'Failed save asset'})
                      })
                    };

                    if (!id && data.asset_type === 'animation') {
                        let hasFbx = false;
                        for (let k in data.variants) {
                            for (let k2 in data.variants[k].ready_links) {
                                if (data.variants[k].ready_links[k2].ext.match(/fbx/i)) {
                                    hasFbx = true;
                                }
                                if (hasFbx) {
                                    break;
                                }
                            }
                            if (hasFbx) {
                                break;
                            }
                        }
                        if (hasFbx) {
                            this.$vs.dialog({
                                type: 'confirm',
                                color: 'danger',
                                title: `You have uploaded a 3D asset, do you want to change asset type to 3D instead of Animation?`,
                                acceptText: "Yes",
                                cancelText: "No",
                                cancel: updateAssetRequest,
                                accept: () => {
                                    data.asset_type = '3d';
                                    updateAssetRequest();
                                }
                            })
                        } else {
                            updateAssetRequest();
                        }
                    } else {
                        updateAssetRequest();
                    }
                } else {
                    this.$vs.notifyWrapper({color: 'danger', title: 'Validation error', text: 'Fill all fields'})
                }
            })
        },
        successThumbnailUpload(event) {
            let res = JSON.parse(event.target.response);
            this.asset.thumbnail = [];
            this.asset.thumbnail.push(res[0].id);
            this.thumbnails = [];
            this.thumbnails.push(res[0]);

            this.$refs.thumbnail.filesx.forEach((item, index) => {
                this.$refs.thumbnail.removeFile(index);
            })

            this.$root.removeLoading('#edit-asset-update-btn');

            this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'Upload Successful'})
        },
        deleteThumbnailUpload(event) {

        },
        errorThumbnailUpload() {
            this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Upload failed'})
        },
        deleteImage() {
            this.thumbnails = [];
        },
        editMetadata(item) {
            this.editMetadataItem = item;
            this.isAddMetaData = true;
        },

        checkName(e) {
            clearTimeout(this.debounce)
            this.isUniqName = false;
            this.$root.addLoading('#save-asset-btn');

            this.debounce = setTimeout(() => {
                this.isLoading = true;

                let url = '/assets/check-name?name=' + e.target.value;
                if (this.asset._id) {
                  url += '&id=' + this.asset._id;
                }
                this.$axios({
                    method: 'get',
                    url: url
                }).then(res => {
                    this.$root.removeLoading('#save-asset-btn');
                    this.isLoading = false;

                    if (res.data) {
                        this.isUniqName = res.data;
                    } else {
                        this.isUniqName = false;
                    }
                }).catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                    this.$root.removeLoading('#save-asset-btn')
                })
            }, 1000)
        },
      updateTranslations(data) {
        if (data) {
          if (data.locales) {
            this.$set(this.asset, 'locales', data.locales);
          }
          if (data.ar_reviewed) {
            this.asset.ar_reviewed = data.ar_reviewed;
            this.asset.ar_reviewed_by = this.$store.state.user.email;
            this.asset.ar_reviewed_at = new Date();
          }
        }
      }
    },
    computed: {
        assetData() {
            return {
                _id: this.asset._id,
                title: this.asset.title,
                thumbnail: this.asset.thumbnail,
                asset_type: this.asset.asset_type,
            }
        },
      metaKg() {
        return this.asset.meta_KG.filter(item => item.status === 'active')
      },
      primaryConcepts() {
        return this.asset.primary_concepts.filter(item => item.status === 'active')
      }
    },
    watch: {
        asset: {
            handler: function (val, oldVal) {
                if (val && oldVal) {
                    this.isChanged = true;
                }
            },
            deep: true
        }
    }
}
</script>
